// Transient 4xx (timeout, too early, rate limited, client closed) can succeed on
// retry and signal capacity problems, so they stay retryable and reportable.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();const TRANSIENT_CLIENT_STATUSES = new Set([408, 425, 429, 499]);

export function isExpectedClientFailure(error: unknown): boolean {
	if (!error || typeof error !== "object") {
		return false;
	}

	if (!("status" in error) || typeof error.status !== "number") {
		return false;
	}

	if (TRANSIENT_CLIENT_STATUSES.has(error.status)) {
		return false;
	}

	return error.status >= 400 && error.status < 500;
}
